import { atomWithStorage } from 'jotai/utils';

/** Which way the steps are built: on the canvas, or as blocks top to bottom. Both edit the same draft. */
export type BuilderView = 'canvas' | 'blocks';

/** The view last chosen in this browser. */
export const builderViewAtom = atomWithStorage<BuilderView>('custom-tools.builder-view', 'canvas', undefined, { getOnInit: true });
